var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunTimelineDowntimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11740_21166)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2929 4.70711L19.2929 1.70711C18.9024 1.31658 18.9024 0.683418 19.2929 0.292893C19.6834 -0.0976311 20.3166 -0.0976311 20.7071 0.292893L23.7071 3.29289C24.0976 3.68342 24.0976 4.31658 23.7071 4.70711C23.3166 5.09763 22.6834 5.09763 22.2929 4.70711ZM3.394 1.28752C3.00474 0.904161 2.37987 0.904161 1.99062 1.28752L0.298312 2.95418C-0.0951824 3.34171 -0.100015 3.97486 0.287516 4.36836C0.675048 4.76185 1.30819 4.76668 1.70169 4.37915L2.69231 3.40354L4.27422 4.96149C2.664 6.86704 1.69231 9.32136 1.69231 12C1.69231 18.0895 6.7005 23 12.8462 23C15.5643 23 18.0584 22.04 19.9949 20.444L22.2983 22.7125C22.6918 23.1 23.325 23.0952 23.7125 22.7017C24.1 22.3082 24.0952 21.675 23.7017 21.2875L20.7277 18.3586L6.36799 4.21645L3.394 1.28752ZM3.69231 12C3.69231 9.87053 4.4437 7.91313 5.70421 6.3698L18.5606 19.0314C16.9952 20.263 15.0098 21 12.8462 21C7.77618 21 3.69231 16.9562 3.69231 12ZM8.77293 3.93766C9.99815 3.33801 11.3804 3 12.8462 3C17.9161 3 22 7.04378 22 12C22 13.436 21.6587 14.7912 21.0518 15.9939C20.803 16.487 21.001 17.0884 21.494 17.3372C21.9871 17.586 22.5885 17.388 22.8373 16.8949C23.5816 15.42 24 13.7569 24 12C24 5.91053 18.9918 1 12.8462 1C11.0698 1 9.3874 1.41023 7.89373 2.14127C7.39767 2.38406 7.19236 2.98301 7.43514 3.47907C7.67793 3.97513 8.27688 4.18044 8.77293 3.93766Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11740_21166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunTimelineDowntimeIcon);
export default __webpack_public_path__ + "static/media/RunTimelineDowntimeIcon.da7b5405ac6446a6ccb01434e30a9b65.svg";
export { ForwardRef as ReactComponent };